import React, { useState } from 'react'
import { Avatar, Button, Card, Divider, Popconfirm, Table } from 'antd'
import moment from 'moment'
import { compose, graphql, withApollo } from 'react-apollo'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../../utils/hooks'
import UserAnnouncementView from './UserAnnouncementView'
import _ from 'lodash'
import {
  fetchUserAnnouncementList,
  deleteUserAnnouncement
} from '../../modules/userAnnouncement'
import { ANNOUNCEMENT_STATUS } from '../../utils/constants'

const UserAnnouncement = () => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  const [formData, setFormData] = useState({})

  const { userAnnouncementList, isLoading } = useSelector(
    (state) => ({
      userAnnouncementList: state.userAnnouncement.userAnnouncementList,
      isLoading: state.userAnnouncement.isLoading
    }),
    []
  )

  useDeepEffect(() => {
    async function fetch() {
      await dispatch(fetchUserAnnouncementList())
    }
    fetch()
  }, [])

  const columns = [
    {
      title: 'วันที่ประกาศ',
      dataIndex: 'createdDate',
      key: 'createdDate',
      render: (date) => <span>{moment(date).format('DD/MM/YYYY')}</span>
    },
    // {
    //   title: 'Material List',
    //   dataIndex: 'binImgList',
    //   key: 'binImgList',
    //   render: (binImgList, record) => (
    //     <div>
    //       {record.moreBinImgList && !_.isEmpty(record.moreBinImgList) ? (
    //         record.moreBinImgList.map((bin, index) => {
    //           return <Avatar key={bin + index} src={bin} size={43} />
    //         })
    //       ) : (
    //         binImgList.map((bin, index) => {
    //           return <Avatar key={bin + index} src={bin} size={43} />
    //         })
    //       )}
    //     </div>
    //   )
    // },
    {
      title: 'Material List',
      dataIndex: 'materialImgList',
      key: 'materialImgList',
      render: (materialImgList, record) => (
        materialImgList.map((bin, index) => {
          return <Avatar key={bin + index} src={bin} size={43} />
        })
      )
    },
    {
      title: 'ส่งร้านรับซื้อ',
      key: 'storeBySelf',
      dataIndex: 'storeBySelf',
      render: (storeBySelf) => <span>{storeBySelf ? 'ใช่' : 'ไม่'}</span>
    },
    {
      title: 'ส่งรถรับซื้อ',
      key: 'storeByHero',
      dataIndex: 'storeByHero',
      render: (storeByHero) => <span>{storeByHero ? 'ใช่' : 'ไม่'}</span>
    },
    {
      title: 'สถานะประกาศ',
      key: 'status',
      dataIndex: 'status',
      render: (status) => <span>{ANNOUNCEMENT_STATUS[status]}</span>
    },
    {
      title: 'ผู้ประกาศ',
      key: 'userName',
      dataIndex: 'userName',
      render: (userName) => <span>{userName}</span>
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="eye"
            onClick={(e) => {
              onClick(e, record)
            }}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.id)}>
            <Button type="danger" size="small" shape="circle" icon="delete" />
          </Popconfirm>
        </span>
      )
    }
  ]

  const onClick = (e, record) => {
    e.preventDefault()
    setVisible(true)
    setFormData(record)
  }

  const onCloseModal = async () => {
    await setVisible(false)
  }

  const onDelete = async (id) => {
    await dispatch(deleteUserAnnouncement(id))
    await dispatch(fetchUserAnnouncementList())
  }

  return (
    <Card title="User Announcement">
      <br />
      <Table
        loading={isLoading}
        bordered
        dataSource={userAnnouncementList}
        columns={columns}
        rowKey={(record) => {
          return record.id
        }}
      />
      <UserAnnouncementView
        visible={visible}
        formData={formData}
        onCancel={onCloseModal}
      />
    </Card>
  )
}

export default compose(
  withApollo
)(UserAnnouncement)
